import React from 'react';

import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useParams } from 'react-router';
import Page from '../page/Page';
import SubOrderTable from './SubOrderTable';
import useOrderDetails from '../../hooks/orders/useOrderDetails';

const useStyles = makeStyles(() => createStyles({
  root: {
    flexGrow: 1,
  },
  paper: {
    //   padding: theme.spacing(2),
    textAlign: 'center',
    //   color: theme.palette.text.secondary
  },
  queryContainer: {
    textAlign: 'center',
    height: '8rem',
    lineHeight: '6rem',
  },
}));

const lineItemsSubOrders = (lineItems: any[]) => {
  const subOrders: {name: string, lineItems: any[]}[] = [];
  lineItems.forEach((li) => {
    const item = li.node;
    const fulfillmentService = item.fulfillmentService.serviceName;
    const subOrder = subOrders.find((so) => so.name === fulfillmentService);
    if (subOrder === undefined) {
      const nSubOrder = { name: fulfillmentService, lineItems: [item] };
      subOrders.push(nSubOrder);
    } else {
      subOrder.lineItems.push(item);
    }
  });
  return subOrders;
};

const OrderDetailsPage = () => {
  const { id } = useParams();
  const classes = useStyles();
  const { data, loading } = useOrderDetails(id ?? '');

  if (loading) return <div />;

  const subOrders = lineItemsSubOrders(data?.order?.lineItems?.edges);

  return (
    <Page>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={1} />
          <Grid item className={classes.queryContainer} xs={10}>
            { subOrders.map((so) => (
              <>
                <br />
                <SubOrderTable subOrder={so} />
              </>
            )) }
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </div>
    </Page>
  );
};

export default OrderDetailsPage;
